<div class="input-group">
    <input class="form-control" [(ngModel)]="data" [type]="isVisible ? 'text' : 'password'" (change)="onChange()" />
    <div class="input-group-append">
        <button class="btn btn-primary" type="button" (click)="toggleVisibility()">
            @if (!isVisible) {
                <i class="far fa-eye text-white"></i>
            }
            @if (!isVisible) {
                <span>{{ 'Show' | localize }}</span>
            }
            @if (isVisible) {
                <i class="far fa-eye-slash text-white"></i>
            }
            @if (isVisible) {
                <span>{{ 'Hide' | localize }}</span>
            }
        </button>
    </div>
</div>
